import { createSelector } from 'reselect'

export const getIncomingMailsDomain = (state, props) => {
  return state.kanbo.config.incomingMailDomain
}

const getCardTemplateId = (state, props) => {
  return state.kanbo.incomingMails.byName[props.name].cardTemplateId
}

export const getValidateAddress = (state, props) => {
  return state.kanbo.incomingMails.byName[props.name].validateAddress
}

export default createSelector(
  [
    getIncomingMailsDomain,
    getCardTemplateId,
    getValidateAddress
  ],
  (
    incomingMailsDomain,
    cardTemplateId,
    validateAddress
  ) => ({
    incomingMailsDomain,
    cardTemplateId,
    validateAddress
  })
)
